import React from 'react';

import {
	useIsObjectSidebarShown,
	useObjectSidebarActions,
	usePanel,
} from '@confluence/object-sidebar-api';

export function useCreateObjectSidebarProp() {
	const isObjectSidebarShown = useIsObjectSidebarShown();
	const panel = usePanel();
	const { changeHeaderElements, showObjectSidebar, hideObjectSidebar, hideObjectSidebarByPanelId } =
		useObjectSidebarActions();

	/**
	 * DON'T REMOVE useMemo here, otherwise it will cause very very serious performance issue
	 */
	return React.useMemo(() => {
		return {
			state: { isObjectSidebarShown, panel },
			actions: {
				changeHeaderElements,
				showObjectSidebar,
				hideObjectSidebar,
				hideObjectSidebarByPanelId,
			},
		};
	}, [
		isObjectSidebarShown,
		panel,
		changeHeaderElements,
		showObjectSidebar,
		hideObjectSidebar,
		hideObjectSidebarByPanelId,
	]);
}
